var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 448,
    height: 399,
    viewBox: "0 0 448 399",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M427.509 96.5091C422.624 78.1146 408.231 63.6277 389.955 58.7114C356.83 49.7778 224 49.7778 224 49.7778C224 49.7778 91.1711 49.7778 58.0447 58.7114C39.7693 63.6285 25.3757 78.1146 20.4905 96.5091C11.6145 129.85 11.6145 199.413 11.6145 199.413C11.6145 199.413 11.6145 268.976 20.4905 302.317C25.3757 320.711 39.7693 334.595 58.0447 339.511C91.1711 348.445 224 348.445 224 348.445C224 348.445 356.829 348.445 389.955 339.511C408.231 334.595 422.624 320.711 427.509 302.317C436.385 268.976 436.385 199.413 436.385 199.413C436.385 199.413 436.385 129.85 427.509 96.5091ZM180.557 262.571V136.255L291.576 199.415L180.557 262.571Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.25112b4c1f2d26002cdb1b8c36c41760.svg";
export { ForwardRef as ReactComponent };